import React, { useState } from 'react'
import { useEffect } from 'react'
import { htmlToText, trimString } from '../../components/Helpers/Common'
import { staticFiles } from '../../components/Helpers/Static';

const NO_IMAGE = staticFiles.noImage;

function SharePostCardExport({ item, idx, add, remove, isShow }) {
    const [check, setCheck] = useState(false)

    function handleChange() {
        setCheck(!check)
        if (isShow?.length > 0) {
            remove(item.reflection_id)
        } else {
            add(item.reflection_id)
        }
    }

    useEffect(() => {
        if (isShow === false) {
            setCheck(false)
        }
    }, [isShow])

    let style = (check ? 'bg-blue' : '')
    style += ' appearance-none rounded-full w-full h-full'

    // const CheckBox = () => {

    //     return (
    //         <div className='border-2 border-black rounded-full w-8 h-8 p-1'>
    //             <input type='checkbox' className={style} onChange={handleChange} />
    //         </div>
    //     )
    // }

    return (
        <div className="flex w-full flex-row px-2">
            <div className="flex md:flex-row flex-col-reverse gap-3 w-full justify-between cursor-pointer" onClick={handleChange}>
                <div className="flex flex-col md:flex-row">
                    {/* Image */}
                    <div className="w-full md:w-56 flex-shrink-0 overflow-hidden">
                        <img
                            src={item.reflection_image ? item.reflection_image : NO_IMAGE}
                            alt="postImage"
                            className="export-image-grid object-cover border20px w-full h-auto"
                            onError={(e) => {
                                e.target.src = NO_IMAGE;
                            }}
                        />
                    </div>

                    {/* Content */}
                    <div className="flex-1 pt-2 md:pt-0 md:px-4">
                        <div className="mb-2 font-bold break-words text-base blackColor">
                            {item.reflection_title}
                        </div>
                        <div className="break-words text-sm lightColor">
                            {trimString(htmlToText(item.reflection_content), 300)}
                        </div>
                    </div>
                </div>
                <div className="flex gap-2 items-center">
                    {/* <p className='font-semibold blackColor text-base'>{idx + 1}</p> */}
                    <div className="flex cursor-pointer mt-1">
                        <input
                            type="checkbox"
                            className="cursor-pointer w-4 h-4 checkBoxCustom"
                            checked={isShow?.length > 0 ? true : false} onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SharePostCardExport
